import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class JDialog extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, dialog, button1) {
    super(scene);

    this.enabled = true;

    this.dialogBitmap = ABCyaPhaser.Images.addImage(0,-100,dialog, this);

    this.button1 = ABCyaPhaser.Images.addImage(0,200,button1, this).setInteractive();
    this.button1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick1,this);
    this.button1.enabled = true;
    this.doAction1 = () => {};
  }

  doClick1 () {
    if (!this.enabled || !this.button1.enabled) { return; }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.doAction1();
  }
}